import { useState } from 'react';

function readStoredRefreshInterval(storageKey: string) {
  const storedValue = globalThis.localStorage?.getItem(storageKey);
  const intervalMs = Number(storedValue ?? 0);

  return Number.isFinite(intervalMs) ? intervalMs : 0;
}

export function useStoredRefreshInterval(storageKey: string) {
  const [refreshIntervalMs, setRefreshIntervalMs] = useState(() =>
    readStoredRefreshInterval(storageKey)
  );
  const [draftRefreshIntervalMs, setDraftRefreshIntervalMs] = useState(refreshIntervalMs);

  const applyRefreshInterval = () => {
    setRefreshIntervalMs(draftRefreshIntervalMs);
    globalThis.localStorage?.setItem(storageKey, String(draftRefreshIntervalMs));
  };

  return {
    applyRefreshInterval,
    draftRefreshIntervalMs,
    refreshIntervalMs,
    setDraftRefreshIntervalMs,
  };
}
